import { useMutation } from "@tanstack/react-query";
import smsTemplateService from "..";

function useUpdateTemplate() {
  return useMutation({
    mutationFn: smsTemplateService.updateCustomTemplate,
  });
}

export default useUpdateTemplate;
